export const DIIA_DEEPLINK_REQUEST = "Diia.Deeplink.Request";
export const DIIA_DEEPLINK_SUCCESS = "Diia.Deeplink.Success";
export const DIIA_DEEPLINK_FAILURE = "Diia.Deeplink.Failure";

export function login() {
  return (dispatch:any) => {
    dispatch({ type: DIIA_DEEPLINK_REQUEST });
    return fetch("/api/diia/auth/deeplink", {
      method: "POST",
    }).then(async (response) => {
      const data = response.ok ? await response.json() : {};
      if (data.status === "success") {
        dispatch({
          type: DIIA_DEEPLINK_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: DIIA_DEEPLINK_FAILURE });
      }
    });
  };
}

export function signDocs(docs, type = undefined, token = undefined) {
  return (dispatch, getState) => {
    const url = (type === "ite")
      ? `/api/ite/diia?token=${token}`
      : "/api/diia/sign/deeplink";
    const headers = { "Content-Type": "application/json" };
    if (type !== "ite" && type !== "pub") {
      const { auth } = getState();
      headers.Authorization = `Bearer ${auth.token}`;
    }
    dispatch({ type: DIIA_DEEPLINK_REQUEST });
    return fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify({ docs }),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({
          type: DIIA_DEEPLINK_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({
          type: DIIA_DEEPLINK_FAILURE,
          payload: data,
        });
      }
    });
  };
}

export const DIIA_AUTH_REQUEST = "Diia.Auth.Request";
export const DIIA_AUTH_SUCCESS = "Diia.Auth.Success";
export const DIIA_AUTH_FAILURE = "Diia.Auth.Failure";

export function auth(requestId) {
  return (dispatch) => {
    dispatch({ type: DIIA_AUTH_REQUEST });
    return fetch("/api/diia/auth", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ requestId }),
    }).then(async (response) => {
      const data = response.ok ? await response.json() : {};
      if (data.status === "success") {
        localStorage.setItem("token", data.result.token);
        dispatch({
          type: DIIA_AUTH_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: DIIA_AUTH_FAILURE });
      }
    });
  };
}

export const DIIA_SIGN_REQUEST = "Diia.Sign.Request";
export const DIIA_SIGN_SUCCESS = "Diia.Sign.Success";
export const DIIA_SIGN_FAILURE = "Diia.Sign.Failure";

export function sign(requestId, docs) {
  return (dispatch) => {
    dispatch({ type: DIIA_SIGN_REQUEST });
    return fetch("/api/diia/sign", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ requestId }),
    }).then(async (response) => {

      const data = response.ok ? await response.json() : {};
      // const data = {status: "success", result: {list:[]}};
      if (data.status === "success") {
        const signatures =
          JSON.parse(localStorage.getItem("publicSignatures")) || [];
        docs.map((i) => signatures.push(i.id));
        localStorage.setItem("publicSignatures", JSON.stringify(signatures));

        dispatch({
          type: DIIA_SIGN_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({ type: DIIA_SIGN_FAILURE });
      }
    });
  };
}

export const DIIA_RESET = "Diia.Reset";
